var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"content"}},[_c('div',{attrs:{"id":"about"}},[_c('div',{attrs:{"id":"plan"}},[(_vm.$i18n.locale=='en')?_c('div',{attrs:{"id":"infoplan"},domProps:{"innerHTML":_vm._s(_vm.info.remark_en)}}):_c('div',{attrs:{"id":"infoplan"},domProps:{"innerHTML":_vm._s(_vm.info.remark)}})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3264ad8c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/Plan.vue
// module id = null
// module chunks = 